import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Slider from "react-slick";
import { getReviewDetailList } from "../../store/Slice/reviewDetailSlice";

const Testimonials = ({ labelDetailData }) => {
  const dispatch = useDispatch();

  const noImage = "/assets/images/no-image.png";

  const { reviewDetailData, loading } = useSelector(
    (state) => state.reviewDetailList
  );

  React.useEffect(() => {
    dispatch(getReviewDetailList({ eType: "Customer" }));
  }, [dispatch]);

  const getLabels = React.useMemo(() => {
    if (labelDetailData?.code !== 200) return {};
    return labelDetailData.data.reduce((acc, item) => {
      acc[item.vLabel] = item.tText;
      return acc;
    }, {});
  }, [labelDetailData]);

  const testimonialTitle = getLabels["LBL_HOME_TESTIMONIALS_HEADING"];
  const testimonialHeading = getLabels["LBL_HOME_TESTIMONIALS_SUB_HEADING"];
  const testimonialSubHeading = getLabels["LBL_HOME_TESTIMONIALS_DESCRIPTION"];

  const settings = {
    slidesToShow: 4,
    slidesToScroll: 1,
    swipeToSlide: true,
    infinite: true,
    centerMode: false,
    responsive: [
      { breakpoint: 1399, settings: { slidesToShow: 3, slidesToScroll: 1 } },
      { breakpoint: 991, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 767, settings: { slidesToShow: 1 } },
      { breakpoint: 575, settings: { slidesToShow: 1 } },
    ],
  };

  const testimonials =
    reviewDetailData?.code === 200 ? reviewDetailData.data : [];

  const getValidImageSrc = (review) => {
    if (
      review?.customer?.vWebpImage &&
      !review.customer.vWebpImage.endsWith("/null")
    ) {
      return review.customer.vWebpImage;
    }
    if (review?.vWebpImage && !review.vWebpImage.endsWith("/null")) {
      return review.vWebpImage;
    }
    return noImage;
  };

  return (
    <section className="testimonial-section pb-100">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-9">
            <span className="small-title">{testimonialTitle}</span>
            <h2 className="main-title">{testimonialHeading}</h2>
            <p className="mb-0">{testimonialSubHeading}</p>
          </div>
        </div>
      </div>

      {!loading && testimonials.length > 0 ? (
        <div className="testimonial-container pt-50">
          <Slider {...settings} className="testimonial-slider">
            {testimonials.map((review, index) => (
              <div className="testimonial-card" key={review.id || index}>
                <div className="testimonial-imgcontent">
                  {/* <img
                    className="testimonial-img"
                    // src={
                    //   (review?.customer?.vWebpImage &&
                    //     !review?.customer?.vWebpImage.endsWith("/null")) ? review?.customer?.vWebpImage : review.vWebpImage : noImage
                    //   (review.vWebpImage &&
                    //     !review?.vWebpImage.endsWith("/null"))
                    //     ? review.vWebpImage
                    //     : noImage
                    // }
                    src={getValidImageSrc(review)}
                    width="400"
                    height="400"
                    alt={review?.vImageAlt || "testimonial"}
                    loading="lazy"
                  /> */}
                  <div>
                    <h3 className="howitwork-title">{review.vName}</h3>
                    {/* <p className="mb-0">{review.vRole}</p> */}
                  </div>
                </div>
                <p>{review.tDescription}</p>
                <div className="rating-quoteDiv">
                  <span className="star-ratings-css" title={review.iRating}>
                    <i style={{ width: `${(review.iRating / 5) * 100}%` }}></i>
                  </span>
                  {/* SVG quote remains the same */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="89"
                    height="68"
                    viewBox="0 0 89 68"
                    fill="none"
                  >
                    <g opacity="0.1">
                      <path
                        d="M5.78027 6.38281C12.7314 9.99693 18.5275 15.4826 22.5039 22.2188L22.5078 22.2256L22.5117 22.2314C24.3808 25.623 25.5945 29.3312 26.0918 33.1631L26.1816 33.9307L26.2715 34.792L25.4805 34.4395C22.4309 33.0794 19.0533 32.6346 15.7617 33.1523L15.1045 33.2686C11.8262 33.9149 8.81297 35.4968 6.42969 37.8135L5.96094 38.2871C3.66339 40.701 2.12592 43.7245 1.5293 46.9854L1.42285 47.6406C0.952425 50.9316 1.45665 54.2827 2.86621 57.2861L3.16016 57.8818V57.8828C5.95046 63.2979 10.5477 65.8518 15.3242 66.4424C19.9708 67.0168 24.7794 65.7302 28.2227 63.3945L28.5518 63.165C33.2749 59.7119 36.5433 54.649 37.7422 48.9551L37.8516 48.4023L37.8545 48.3887L37.9639 47.8584C39.0202 42.5437 38.9127 37.0646 37.6484 31.7949L37.5176 31.2686C36.1315 25.8384 33.5472 20.7858 29.9541 16.4775L29.6035 16.0635L29.5947 16.0537C24.3036 9.55916 17.5691 4.3756 9.9209 0.913086L9.63867 0.823242L5.78027 6.38281Z"
                        stroke="black"
                      />
                      <path
                        d="M55.1719 6.40332C66.0062 12.5014 73.9427 20.8807 75.6787 33.9893L75.8018 34.9238L74.959 34.502C72.6843 33.365 70.1508 32.8373 67.6084 32.9707L67.5938 32.9717H67.5801C63.5671 32.9581 59.6785 34.3528 56.5977 36.9102C53.6131 39.3876 51.5718 42.8021 50.8057 46.585L50.7354 46.9521V46.9531C50.2976 49.3827 50.4088 51.8767 51.0576 54.2549L51.1943 54.7295C51.9149 57.0916 53.1533 59.263 54.8184 61.0879L55.1572 61.4482C56.8789 63.2264 58.9753 64.5996 61.293 65.4717L61.7588 65.6396C64.2616 66.4981 66.9341 66.7537 69.5557 66.3857H69.5566C77.2437 65.2923 82.1364 60.7379 85.2158 54.1172L85.5078 53.4697C87.1289 49.6547 88.0231 45.5757 88.1484 41.4404L88.1631 40.6123C88.1856 36.4688 87.4353 32.36 85.9521 28.4932L85.6465 27.7227L85.6426 27.7148C81.8814 18.1145 75.0203 10.0294 66.1377 4.73047L66.126 4.72266C63.8871 3.29692 61.5573 2.08746 59.1143 0.725586L55.1719 6.40332Z"
                        stroke="black"
                      />
                    </g>
                  </svg>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      ) : (
        !loading && (
          <div className="col-12">
            <p className="text-center py-3">No Data Found</p>
          </div>
        )
      )}
    </section>
  );
};

export default Testimonials;
